var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20C18.9286 20 17.6429 21.2857 17.6429 22.8571C17.6429 24.4286 18.9286 25.7143 20.5 25.7143C22.0714 25.7143 23.3571 24.4286 23.3571 22.8571C23.3571 21.2857 22.0714 20 20.5 20ZM29.8348 14.3348L26.0893 10.5893C25.7277 10.2259 25.1786 10 24.6116 10H13.3571C11.779 10 10.5 11.279 10.5 12.8571V27.1429C10.5 28.721 11.779 30 13.3571 30H27.6429C29.221 30 30.5 28.721 30.5 27.1429V15.8884C30.5 15.3214 30.2723 14.7723 29.8348 14.3348ZM16.2143 12.1429H22.6429V15.7143H16.2143V12.1429ZM28.3571 27.1429C28.3571 27.5373 28.0373 27.8571 27.6429 27.8571H13.3571C12.9627 27.8571 12.6429 27.5373 12.6429 27.1429V12.8571C12.6429 12.4626 12.9627 12.1429 13.3571 12.1429H14.0714V16.7857C14.0714 17.3772 14.5513 17.8571 15.1429 17.8571H23.7143C24.308 17.8571 24.7857 17.3795 24.7857 16.7857V12.3161L28.279 15.8094C28.3304 15.8571 28.3571 15.9286 28.3571 15.9955V27.1429Z",
    fill: "#1A2021"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.22bfb1280e7cbed2050325377a7da0df.svg";
export { ForwardRef as ReactComponent };